import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-b243a66a")
const _hoisted_1 = {
  class: "loader",
  xmlns: "http://www.w3.org/2000/svg",
  width: "66",
  height: "66",
  viewBox: "0 0 66 66",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "33",
  cy: "33",
  r: "29",
  stroke: "#EFEFEF",
  "stroke-width": "8"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M33 4C49.0163 4 62 16.9837 62 33C62 40.7538 58.957 47.7968 54.0001 53",
  stroke: "black",
  "stroke-width": "8"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}